import React, {Fragment, useEffect, useState} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";

const Alquiler = () => {

    const [properties, setProperties] = useState([]);

    const fetchProperties = async () => {
        try {
            const req = await axios({
                method: "GET",
                url: "https://api.airtable.com/v0/tblX17h6rDRqXwwF0/Propiedades",
                headers: {
                    "Authorization": `Bearer patEytY5wbH8JCEmO.11a55a9f48b8a087a429af079853aafaf9e36544bcf527eb9ca6aef91c71ab6d`,
                }
            });
            console.log(req.data)
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchProperties()
    }, []);

    return (
        <Fragment>
            <Header/>
            <section className="section text-center">
                <h2>Casas en Alquiler</h2>
                <p>Aquí puedes ver todas las propiedades disponibles para alquilar.</p>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="propiedad">
                                <img src="imagenes/casa mesada 1 .jpg" alt="Casa en alquiler" className="img-fluid"/>
                                <span className="precio">$40,000</span>
                                <h3>3 dormitorios</h3>
                                <p><strong>Ubicación:</strong> Calle Principal</p>
                                <p>Somos un estudio jurídico e inmobiliario dedicado a brindar soluciones integrales en
                                    asesoría legal y servicios inmobiliarios...</p>
                                <button className="btn btn-primary" onClick="verDetalle('casa')">Detalles</button>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="propiedad">
                                <img src="img/casa2.jpg" alt="Casa en alquiler" className="img-fluid"/>
                                <span className="precio">$55,000</span>
                                <h3>2 dormitorios</h3>
                                <p><strong>Ubicación:</strong> Calle Tranquila</p>
                                <p>En nuestro estudio entendemos la importancia de encontrar un hogar que realmente
                                    puedas llamar tuyo...</p>
                                <button className="btn btn-primary" onClick="verDetalle('casa')">Detalles</button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="propiedad">
                                <img src="img/casa3.jpg" alt="Casa en alquiler" className="img-fluid"/>
                                <span className="precio">$50,000</span>
                                <h3>4 dormitorios</h3>
                                <p><strong>Ubicación:</strong> Avenida Central</p>
                                <p>Nuestro equipo de profesionales está comprometido en ofrecer un servicio
                                    personalizado...</p>
                                <button className="btn btn-primary" onClick="verDetalle('casa')">Detalles</button>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="propiedad">
                                <img src="img/casa4.jpg" alt="Casa en alquiler" className="img-fluid"/>
                                <span className="precio">$45,000</span>
                                <h3>3 dormitorios</h3>
                                <p><strong>Ubicación:</strong> Avenida del Parque</p>
                                <p>Nos enorgullecemos de ofrecer un catálogo diverso de propiedades en alquiler...</p>
                                <button className="btn btn-primary" onClick="verDetalle('casa')">Detalles</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </Fragment>
    );
}

export default Alquiler;